import { render, staticRenderFns } from "./Alltrips.vue?vue&type=template&id=45e29c4a&"
import script from "./Alltrips.vue?vue&type=script&lang=js&"
export * from "./Alltrips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports